const General = {
    apiUrl: 'https://my.cloudex.lv/cloudex-api/api/v1/cloudex-drive-web',
    slackWebhook: 'https://hooks.slack.com/services/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',
    temp: [-25, -24, -23, -22, -21, -20, -19, -18, -17, -16, -15, -14, -13, -12, -11, -10, -9, -8, -7, -6, -5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
}

export default General;